module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG291cc0fbf99e0a6baca351c026dc8a9a.291cc0fb.png";